<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['d-flex', getSelectedDEV && 'dev-selected-component']">
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-layout class="mx-0">
      <v-text-field
        v-bind="schema.attributesTextField"
        :disabled="schema.readonly"
        v-model="itemText"
        :name="schema.model"
        :id="setId(schema.model)"
        :rules="rules"
        @click:append="ToogleShowCard"
        @click:clear="clear()"
        @blur="onBlur"
        @change="onChange"
        @focus="onFocus"
        @input="onInput"
      >
        <template v-slot:label>
          {{ schema.attributesTextField.label }}
          <span v-if="schema.rules.includes('required')" class="red--text">*</span>
        </template>
      </v-text-field>

      <v-dialog v-model="showDialog" v-bind="schema.attributesDialog">
        <v-card>
          <v-toolbar :color="schema.attributesDialog.cardTolbarColor">
            <v-btn icon @click="ToogleShowCard">
              <v-icon>close</v-icon>
            </v-btn>

            <v-toolbar-title primary-title>{{ schema.attributesDialog.cardTolbarTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text class="pt-1 pb-1">
            <i4proTable
              :items="items"
              :schema="schema.attributesTable"
              :headers="schema.attributesTable.headers"
              :lookupwindow="true"
              @select-item="selectItem"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import i4proTextField from '@/components/inputs/i4pro-text-field';
import devComponentMixin from '@/mixins/dev-component-mixin';
import pageServices from '@/services/page';
import rulesMixin from '@/mixins/rules-mixin';

export default {
  mixins: [i4proTextField, devComponentMixin, rulesMixin],

  components: {
    i4proTable: () => import('@/components/tables/i4pro-table'),
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    showDialog: false,
    init: true,
    items: [],
    itemText: ''
  }),

  watch: {
    model() {
      this.getLookupText();
    }
  },

  methods: {
    clear() {
      this.$nextTick(() => {
        this.model[this.schema.model] = '';
        this.itemText = '';
      });
    },

    setId(field) {
      return this.formOptions.mode === 'list' ? `${field}_${this.formOptions.index}` : field;
    },

    selectItem(item) {
      this.model[this.schema.model] = item[this.schema.searchParams.value];
      this.itemText = item[this.schema.searchParams.text];
      this.showDialog = false;

      if (this.schema.visible && this.schema.fill.length > 0) {
        this.$store.dispatch('page/lookup', { fill: this.schema.fill, model: this.model, info: this.formOptions });
      }

      if (this.schema.hasConditions) this.$store.dispatch('page/conditions', this.formOptions);
      if (this.schema.visible && this.schema.fill.length > 0) {
        this.$store.dispatch('page/lookup', {
          fill: this.schema.fill,
          model: this.model,
          info: this.formOptions
        });
      }
    },

    async getLookupText() {
      if (this.init && this.model) {
        if (this.model[this.schema.model]) {
          const model = { ...JSON.parse(JSON.stringify(this.model)), ...{ id: this.model[this.schema.model] } };
          const lookupWindow = {
            procedure: this.schema.searchParams.procedure,
            model,
            page: this.formOptions.page
          };

          const { data } = await pageServices.lookupWindow(lookupWindow);

          this.itemText = data.values[0][this.schema.searchParams.text];
        }

        this.init = false;
      }
    },

    async ToogleShowCard() {
      let show = !this.showDialog;

      if (show) {
        const model = { ...JSON.parse(JSON.stringify(this.model)), ...{ like: this.itemText } };
        const lookupWindow = {
          procedure: this.schema.searchParams.procedure,
          model,
          page: this.formOptions.page
        };

        const { data } = await pageServices.lookupWindow(lookupWindow);

        if (data.valid) this.items = data.values;
      } else this.items = [];

      this.showDialog = show;
    }
  }
};
</script>
